import { useNavigate } from "react-router";
import useFetch from "../../hooks/useFetch";

const GriqnaTable = () => {
    const userdetails = JSON.parse(localStorage.getItem('userdetails'));
    const { data, isLoading } = useFetch(`gri/company?company_id=${userdetails.company_id}`);
    const navigate = useNavigate();

    function formatDate(isoDate) {
        if (!isoDate) return 'N/A';
        
        const date = new Date(isoDate);
        const day = String(date.getDate()).padStart(2, '0');
        const month = date.toLocaleString('default', { month: 'short' });
        const year = date.getFullYear();
        
        return `${day} ${month} ${year}`;
    }

    const handleClick = (id) => {
        const routes = `/griqnadetails`;
        navigate(routes, { state: id });
    };

    if (isLoading) {
        return (
            <tr>
                <td colSpan="3" className="text-center">
                    <i className="fa-solid fa-spinner fa-spin"></i> Loading...
                </td>
            </tr>
        );
    }

    if (!data || data.length === 0) {
        return (
            <tr>
                <td colSpan="3" className="text-center">No GRI QnA reports available.</td>
            </tr>
        );
    }

    return (
        <>
            {data.map((curData, index) => {
                const { company_id, id, createdAt } = curData;

                return (
                    <tr className='clickablerow'
                        key={id}
                        onClick={() => handleClick(company_id)}>
                        <td>{index + 1}</td>
                        <td>{new Date(createdAt).getFullYear()}</td>
                        <td>{formatDate(createdAt)}</td>
                    </tr>
                )
            })}
        </>
    );
};

export default GriqnaTable;